import { useAppSelector } from "@hooks/useTypedRedux";
import { useGetFeatureFlagsQuery } from "@services/featureFlagsApi";
import { selectFeatureFlags } from "@features/featureFlags/featureFlagsSlice";
import { EFeatureFlags } from "../enums/EFeatureFlags";

interface IFeatureFlag {
  isEnabled: boolean;
  isFetching: boolean;
  isError: boolean;
}

export const useGetFeatureFlag = (featureFlag: EFeatureFlags): IFeatureFlag => {
  const { isFetching, isError } = useGetFeatureFlagsQuery();
  const featureFlags = useAppSelector(selectFeatureFlags);

  const isEnabled = featureFlags?.includes(featureFlag) ?? false;

  return {
    isEnabled,
    isFetching,
    isError,
  };
};
